import React, { Component } from 'react';
import { Tooltip } from 'antd';

import './TextPreview.css';

class TextPreview extends Component {
  constructor(props) {
    super(props);
    this.hasOverflowingChildren = false;
  }

  componentDidMount() {
    // const element = this.elementShouldNotOverflow;
    // this.hasOverflowingChildren = element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth;
    // this.setState({
    //   hasOverflow: hasOverflowingChildren
    // });
    this.forceUpdate();
  }

  componentDidUpdate() {
    // const element = this.elementShouldNotOverflow;
    // this.hasOverflowingChildren = element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth;
    // this.setState({
    //   hasOverflow: hasOverflowingChildren
    // });
  };

  render() {
    return (
      <div className="TextPreview" style={{width: this.props.width}} ref={(el) => {
          if (el!==null) {
            this.elementShouldNotOverflow = el;
            this.hasOverflowingChildren = el.offsetHeight < el.scrollHeight || el.offsetWidth < el.scrollWidth;
          }
        }}>
        {!!this.hasOverflowingChildren &&
          <Tooltip placement="topLeft" title={String(this.props.children)}>
            {this.props.children}
          </Tooltip>
        }
        {!this.hasOverflowingChildren && this.props.children}
      </div>
    );
  }
}

TextPreview.defaultProps = {
  width: '100px'
};

export default TextPreview;
